// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__YNEZ1","title":"AfterFrontImage_title__H81qK"};